const LANDING_PATHS = [
  '/acneproject',
  '/bioderma_atoderm',
  '/bioderma_hydrabio',
  '/bioderma_sebium',
  '/bioderma_galchonok',
  '/ie_intensive_hyaluronic',
  '/ie_ageproteom',
  '/ie_intensive_nad',
  '/eau-cellulaire',
  '/sochetannye_metodiki'
] as const;

export const isLandingPath = (pathname: string) => {
  const path = pathname.toLowerCase().replace(/\/+$/, '') || '/';

  return LANDING_PATHS.some(
    (landing) => path === landing || path.startsWith(`${landing}/`)
  );
};
